// extracted by mini-css-extract-plugin
export default {"expenseChart":"BarChart_expenseChart__4Z7pt","barWrapper":"BarChart_barWrapper__aZRPl"};